import * as d3 from "../assets/d3";
import { flatten } from "lodash";
import { ObjectType } from "../interfaces/object";
import { AxisType, AxisMode } from "../interfaces/axis";
import { getElementXId, getElementZId } from "../utils";
const computeExtend = (data, values, axis, objects, applyPadding, elements, isHistogram, ignoreFileName) => {
    let axisExtendsMap = values === null || values === void 0 ? void 0 : values.map((d) => {
        var _a;
        const noNullArray = (_a = data === null || data === void 0 ? void 0 : data[d]) === null || _a === void 0 ? void 0 : _a.filter((item) => item);
        return (noNullArray === null || noNullArray === void 0 ? void 0 : noNullArray.length) > 0
            ? noNullArray.length > 1
                ? d3.extent(noNullArray)
                : data[d]
            : null;
    }).filter((item) => item);
    const axisExtends = (axisExtendsMap === null || axisExtendsMap === void 0 ? void 0 : axisExtendsMap.length) > 0 ? axisExtendsMap : [[-1, 1]];
    if (axis.type === AxisType.x && isHistogram) {
        elements.forEach((element) => {
            const xId = getElementXId(element, ignoreFileName);
            const zId = getElementZId(element, ignoreFileName);
            const elementExtend = d3.extent(data[xId]);
            elementExtend[0] = elementExtend[0] - data[zId][0];
            elementExtend[1] = elementExtend[1] + data[zId][data[zId].length - 1];
            axisExtends.push(elementExtend);
        });
    }
    if (objects) {
        objects.forEach((object) => {
            if (axis.type === AxisType.x) {
                switch (object.type) {
                    case ObjectType.horizon:
                        break;
                    case ObjectType.vband:
                    case ObjectType.vertical:
                        axisExtends.push(d3.extent(object.coords));
                        break;
                    case ObjectType.oval:
                        const centreX = object.coords[0];
                        const semiX = object.coords[2];
                        axisExtends.push([centreX - semiX, centreX + semiX]);
                        break;
                    default:
                        let objectValues = object.coords.filter((_, index) => index % 2 === 0);
                        axisExtends.push(d3.extent(objectValues));
                }
            }
            else {
                switch (object.type) {
                    case ObjectType.vband:
                    case ObjectType.vertical:
                        break;
                    case ObjectType.oval:
                        const centreY = object.coords[1];
                        const semiY = object.coords[3];
                        axisExtends.push([centreY - semiY, centreY + semiY]);
                        break;
                    case ObjectType.horizon:
                        axisExtends.push(d3.extent(object.coords));
                        break;
                    default:
                        let objectValues = object.coords.filter((_, index) => index % 2 !== 0);
                        axisExtends.push(d3.extent(objectValues));
                }
            }
        });
    }
    if (axisExtends.length < 1) {
        axisExtends.push([0, 0]);
    }
    const preciseExtends = d3.extent(flatten(axisExtends));
    if (applyPadding && !isHistogram) {
        const margin = 0.02;
        const range = preciseExtends[1] - preciseExtends[0] === 0
            ? 0.5
            : preciseExtends[1] - preciseExtends[0];
        preciseExtends[0] = preciseExtends[0] - range * margin;
        preciseExtends[1] = preciseExtends[1] + range * margin;
    }
    if (preciseExtends[0] === preciseExtends[1]) {
        const delta = Math.max(Math.abs(preciseExtends[0]) * 0.01, Number.EPSILON);
        preciseExtends[0] = preciseExtends[0] - delta;
        preciseExtends[1] = preciseExtends[1] + delta;
    }
    if (axis.minValue !== null) {
        preciseExtends[0] = axis.minValue;
    }
    if (axis.maxValue !== null && axis.maxValue > preciseExtends[0]) {
        preciseExtends[1] = axis.maxValue;
    }
    return preciseExtends;
};
const computeRange = (axis, margins, svgDimensions) => {
    if (axis.type === AxisType.x) {
        return [margins.left, svgDimensions.width - margins.right];
    }
    else {
        return [svgDimensions.height - margins.bottom, margins.top];
    }
};
export const computeScale = (data, values, axis, margins, svgDimensions, _extend, objects, applyPadding, elements, isHistogram) => {
    let extend = _extend;
    if (_extend === null) {
        extend = computeExtend(data, values, axis, objects, applyPadding, elements, isHistogram);
    }
    const range = computeRange(axis, margins, svgDimensions);
    switch (axis.mode) {
        case AxisMode.Date:
            return d3.scaleLinear().range(range).domain(extend);
        case AxisMode.Logarithmic:
            if (extend[0] > 0) {
                return d3.scaleLog().range(range).domain(extend);
            }
            return d3.scaleSymlog().range(range).domain(extend);
        case AxisMode.Linear:
            return d3.scaleLinear().range(range).domain(extend);
        default:
            throw new Error(`Invalid Scale : ${axis.mode}`);
    }
};
//# sourceMappingURL=scale.js.map